import {
  Box,
  Drawer,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import HomeIcon from "@mui/icons-material/Home";
import SchoolIcon from "@mui/icons-material/School";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PetsIcon from "@mui/icons-material/Pets";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ArticleIcon from "@mui/icons-material/Article";
import PhoneIcon from "@mui/icons-material/Phone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const menuItems = [
    { name: "Home", icon: <HomeIcon />, path: "/" },
    { name: "LMS", icon: <SchoolIcon />, path: "/learn" },
    { name: "Consultations", icon: <SelfImprovementIcon />, path: "/services" },
    { name: "Karm Kaand", icon: <FavoriteIcon />, path: "/karmkaand" },
    { name: "Gau Daan", icon: <PetsIcon />, path: "/gaudaan" },
    { name: "Shop", icon: <ShoppingCartIcon />, path: "/shop" },
    { name: "Blog", icon: <ArticleIcon />, path: "/blog" },
    { name: "Contact Us", icon: <PhoneIcon />, path: "/contact-us" },
  ];

  useEffect(() => {
    if (isHomePage) {
      const handleScroll = () => {
        setScrolled(window.scrollY > 0);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    } else {
      setScrolled(true);
    }
  }, [isHomePage]);

  const handleNavigation = (path, name) => {
    setSelected(name);
    navigate(path);
    setMenuOpen(false);
  };
  const [selected, setSelected] = useState(() => {
    const current = menuItems.find((item) => item.path === location.pathname);
    return current ? current.name : "Home";
  });

  // Update selected when route changes
  useEffect(() => {
    const current = menuItems.find((item) => item.path === location.pathname);
    setSelected(current ? current.name : "Home");
  }, [location.pathname]);

  // Header shadow on scroll
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: {
          xs: isHomePage ? (scrolled ? 0 : 120) : 0,
          md: isHomePage ? (scrolled ? 0 : 150) : 0,
        },
        
        left: 0,
        right: 0,
        mx: "auto",
        width: scrolled || !isHomePage ? "100%" : "85%",
        zIndex: 1000,
        bgcolor: "white",
        transition: "all 0.5s ease",
        boxShadow: 2,
        borderRadius: scrolled || !isHomePage ? 0 : 30,
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Mobile View */}
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <IconButton onClick={() => setMenuOpen(true)}>
            <MenuIcon sx={{ color: "#6d1675" }} />
          </IconButton>

          <img
            src={logo}
            alt="Logo"
            style={{ borderRadius: "0%", width: 50, height: 50 }}
          />

          <IconButton>
            <SearchIcon sx={{ color: "#6d1675" }} />
          </IconButton>
        </Box>

        {/* Desktop View */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <img src={logo} alt="Logo" style={{ width: 80, height: 60 }} />

          <Box sx={{ display: "flex", gap: 4 }}>
            {menuItems.map((item) => (
              <Box
                key={item.name}
                onClick={() => handleNavigation(item.path, item.name)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: selected === item.name ? "#6d1675" : "black",
                  textDecoration: selected === item.name ? "underline" : "none",
                  textUnderlineOffset: selected === item.name ? 4 : undefined,
                  textDecorationThickness:
                    selected === item.name ? 2 : undefined,
                  textDecorationColor:
                    selected === item.name ? "#6d1675" : undefined,
                  transition: "color 0.3s",
                }}
              >
                <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>
                  {item.name}
                </Typography>
              </Box>
            ))}
            <AccountCircleIcon
              sx={{ fontSize: 30, mr: 3, cursor: "pointer" }}
              onClick={() => navigate("/account")}
            />
          </Box>
        </Box>
      </Box>

      {/* Drawer for Mobile Menu */}
      <Drawer anchor="left" open={menuOpen} onClose={() => setMenuOpen(false)}>
        <Box sx={{ width: 250, p: 2 }}>
          <List>
            {menuItems.map((item) => (
              <ListItem
                button
                key={item.name}
                onClick={() => handleNavigation(item.path, item.name)}
                sx={{
                  "&:hover": { color: "#6d1675" },
                }}
              >
                <ListItemIcon sx={{ color: "#6d1675" }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.name} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Header;

